/* ====================================================================
   Sensor-1 — mobile "Add to Home Screen" invitation banner
   --------------------------------------------------------------------
   Loads after pwa-install.js. On phones and tablets it slides a bar up
   from the bottom of the screen inviting the customer to add the site
   to their home screen, because Apple provides no way for a website to
   install itself and most customers never find Safari's Share menu on
   their own.

   Behaviour:
     - phones/tablets only (<= 1024px), never inside the installed app
     - waits 4 seconds so it never competes with the page loading
     - Android: the button fires Chrome's real install prompt
     - iOS: the button opens the existing step-by-step instructions
     - dismissing hides it for 30 days
     - never shown to anyone who already installed
   ==================================================================== */
(function () {
  'use strict';

  if (window.__s1PwaBannerInit) return;
  window.__s1PwaBannerInit = true;

  var doc = document;
  var DISMISS_KEY = 's1PwaBannerDismissedAt';
  var DISMISS_DAYS = 30;
  var DELAY_MS = 4000;
  var MAX_WIDTH = 1024;

  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* private mode */ } }

  function isStandalone() {
    return (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
      window.navigator.standalone === true;
  }

  function recentlyDismissed() {
    var at = parseInt(lsGet(DISMISS_KEY) || '0', 10);
    if (!at) return false;
    var days = (Date.now() - at) / 86400000;
    return days < DISMISS_DAYS;
  }

  function ready(fn) {
    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    /* Only where the install feature itself is switched on. */
    if (!doc.getElementById('pwa-install-config')) return;

    /* Never inside the theme editor — it would cover the merchant's preview. */
    if (window.Shopify && window.Shopify.designMode) return;

    if (isStandalone()) return;          /* already running as an app */
    if (recentlyDismissed()) return;     /* respect the customer's no */
    if (window.innerWidth > MAX_WIDTH) return; /* desktop keeps the header tile only */

    var ua = navigator.userAgent;
    var isIOS = /iPhone|iPad|iPod/.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var isAndroid = /Android/.test(ua);

    if (!isIOS && !isAndroid) return;

    var timer = window.setTimeout(showBanner, DELAY_MS);

    /* If the customer is already busy scrolling, don't interrupt — wait
       until they pause before sliding the bar in. */
    function showBanner() {
      window.clearTimeout(timer);
      if (doc.querySelector('.pwa-invite')) return;

      var bar = doc.createElement('div');
      bar.className = 'pwa-invite';
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', 'Add Sensor-1 to your home screen');

      var action = isAndroid ? 'Install' : 'Show me how';

      bar.innerHTML =
        '<div class="pwa-invite__inner">' +
          '<div class="pwa-invite__text">' +
            '<strong class="pwa-invite__title">Add Sensor-1 to your Home Screen</strong>' +
            '<span class="pwa-invite__sub">' +
              (isIOS ? 'Tap Share, then Add to Home Screen' : 'Get one-tap access to parts and manuals') +
            '</span>' +
          '</div>' +
          '<button type="button" class="pwa-invite__go" data-pwa-install-trigger>' + action + '</button>' +
          '<button type="button" class="pwa-invite__close" aria-label="Dismiss">&times;</button>' +
        '</div>' +
        (isIOS ? '<span class="pwa-invite__arrow" aria-hidden="true"></span>' : '');

      doc.body.appendChild(bar);

      /* next frame, so the slide-up transition actually runs */
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { bar.classList.add('is-visible'); });
      });

      bar.querySelector('.pwa-invite__close').addEventListener('click', function () {
        lsSet(DISMISS_KEY, String(Date.now()));
        bar.classList.remove('is-visible');
        window.setTimeout(function () {
          if (bar.parentNode) bar.parentNode.removeChild(bar);
        }, 350);
      });

      /* The Install / Show me how button carries data-pwa-install-trigger,
         so pwa-install.js's delegated click handler does the real work:
         native prompt on Android, instruction dialog on iOS. Once tapped,
         retire the bar either way. */
      bar.querySelector('.pwa-invite__go').addEventListener('click', function () {
        lsSet(DISMISS_KEY, String(Date.now()));
        window.setTimeout(function () {
          bar.classList.remove('is-visible');
          window.setTimeout(function () {
            if (bar.parentNode) bar.parentNode.removeChild(bar);
          }, 350);
        }, 400);
      });
    }

    /* If the app gets installed while the bar is open, take it away. */
    window.addEventListener('appinstalled', function () {
      var bar = doc.querySelector('.pwa-invite');
      if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
    });
  });
})();
